export function DashboardLoadingState() {
  return (
    <div className="flex flex-col h-full bg-[#161717]">
      <div className="h-16 border-b border-neutral-800 flex items-center px-6">
        <div className="w-32 h-6 bg-neutral-800 rounded animate-pulse" />
      </div>
      <div className="flex-1 p-6">
        <div className="bg-[#161717] rounded-xl p-8">
          <div className="space-y-4">
            <div className="w-48 h-4 bg-neutral-800 rounded animate-pulse" />
            <div className="w-full h-4 bg-neutral-800 rounded animate-pulse" />
            <div className="w-3/4 h-4 bg-neutral-800 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
